import React from 'react'
import { RightArrowIcon } from "../../styles/icons/svg";
import './Services.scss';
import moment from 'moment';

const Services = (props) => {

    const { services, handelServiceDetail } = props;

    return (
        <React.Fragment>
            {
                services.length > 0 ?
                    services.map((service, index) => {

                        let dueDate = moment(service.dueDate, 'DD-MMMM-YYYY').format("YYYYMMDD");
                        let curDate = moment().format("YYYYMMDD");
                        let dtExpired = dueDate < curDate ? true : false;

                        return (
                            <div key={index} className="card-contain-service-block">
                                <div className="service-heading" onClick={() => handelServiceDetail(service.serviceTaskId)}>
                                    <div className="service-heading-col1">Service</div>
                                    <div className="service-heading-col2">:</div>
                                    <div title={service.taskTitle} className="service-heading-col3">
                                        {service.taskTitle}
                                    </div>
                                    <div className="service-heading-col4">
                                        <span style={{ marginTop: '3px' }}>
                                            <RightArrowIcon />
                                        </span>
                                    </div>
                                </div>
                                <div className="service-date">
                                    <div className="service-date-col1">Due Date</div>
                                    <div className="service-date-col2">:</div>
                                    <div className={`service-date-col3 ${dtExpired ? 'dt-expired' : ''}`}>
                                        {service.dueDate}
                                    </div>
                                </div>
                                <div className="service-date">
                                    <div className="service-date-col1">
                                        Prev. Service Date
                                    </div>
                                    <div className="service-date-col2">:</div>
                                    <div className="service-date-col3">
                                        {service.lastServiceDate}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                    : <div className="no-services-found">No Services Found !</div>
            }
        </React.Fragment>
    )
}

export default Services
